module.exports = __webpack_public_path__ + "static/media/done-action.77be38bf.svg";